import { BarChart3, Code2, Database, Trophy } from 'lucide-react';
import { cn } from '../../lib/cn';

export function DatabinexScene({ className, compact = false }: { className?: string; compact?: boolean }) {
  return (
    <div className={cn('relative isolate h-[520px] w-[620px] max-w-full', compact && 'h-48 w-80', className)} aria-hidden="true">
      <div className="absolute inset-x-10 bottom-5 h-28 rounded-[50%] bg-brand/20 blur-[44px]" />
      <div className="absolute left-[7%] top-[12%] h-[32%] w-[34%] rounded-[32px] border border-white/10 bg-white/[.035] shadow-[0_24px_80px_rgba(242,106,33,.18)] backdrop-blur-xl" />

      <div className="absolute left-[13%] top-[8%] h-[34%] w-[26%]">
        <div className="dbx-cylinder absolute inset-x-0 top-0 h-[35%]" />
        <div className="dbx-cylinder absolute inset-x-0 top-[22%] h-[35%]" />
        <div className="dbx-cylinder absolute inset-x-0 top-[44%] h-[35%]" />
      </div>

      <div className="absolute left-[24%] top-[47%] grid size-[16%] place-items-center rounded-full border border-gold/45 bg-gold/15 text-gold shadow-[0_0_70px_rgba(248,185,49,.24)]">
        <Trophy className="size-1/2 fill-gold/25" />
      </div>

      <div className="absolute bottom-[13%] left-[10%] h-[29%] w-[42%] -skew-x-12 rounded-[26px] border border-brand/35 bg-gradient-to-br from-brand/20 to-plum/20 shadow-[0_28px_80px_rgba(242,106,33,.24)]">
        <div className="absolute inset-x-[12%] bottom-[18%] h-[38%] rounded-xl bg-plum/70 blur-sm" />
        <div className="absolute left-[12%] top-[20%] grid size-[19%] place-items-center rounded-xl border border-cyan/30 bg-cyan/12 text-cyan">
          <Database className="size-1/2" />
        </div>
      </div>

      <div className="absolute bottom-[18%] left-[39%] h-[28%] w-[30%] rotate-[-1deg] rounded-[18px] border border-white/15 bg-[#FFF7F0] shadow-[0_30px_90px_rgba(0,0,0,.28)]">
        <div className="absolute inset-x-[9%] top-[10%] grid h-[70%] place-items-center rounded-xl bg-gradient-to-br from-brand to-[#172033] text-3xl font-black text-white shadow-inner">
          T-SQL
        </div>
        <div className="absolute -bottom-[16%] left-[6%] h-[17%] w-[112%] rounded-b-[22px] bg-[#FFE2CE]" />
      </div>

      <div className="absolute right-[11%] top-[17%] w-[26%] rotate-[-8deg] rounded-2xl border border-brand/35 bg-[#172033]/88 p-3 shadow-2xl backdrop-blur-md">
        <div className="mb-3 flex items-center justify-between">
          <Code2 className="size-4 text-cyan" />
          <span className="font-mono text-[9px] text-white/35">query.sql</span>
        </div>
        {['SELECT TOP 10', 'SUM(LineTotal)', 'GROUP BY p.Name', 'ORDER BY Revenue'].map((item) => (
          <span key={item} className="mb-2 block h-2 rounded-full bg-white/12">
            <i className="block h-full rounded-full bg-cyan/70" style={{ width: `${52 + item.length * 2}%` }} />
          </span>
        ))}
      </div>

      <div className="absolute bottom-[17%] right-[3%] w-[25%] rotate-[7deg] rounded-2xl border border-white/12 bg-[#172033]/78 p-3 shadow-2xl backdrop-blur-md">
        <div className="mb-3 flex items-center gap-2 text-[9px] font-black text-white/55">
          <BarChart3 className="size-4 text-gold" /> Live score
        </div>
        <div className="flex h-20 items-end gap-2">
          {[42, 68, 54, 86].map((height, index) => (
            <span key={index} className="flex-1 rounded-t-lg bg-gradient-to-t from-brand to-cyan" style={{ height: `${height}%` }} />
          ))}
        </div>
      </div>

      <div className="absolute left-[36%] top-[38%] size-[8%] rotate-45 rounded-xl bg-plum shadow-[0_0_34px_rgba(242,106,33,.65)]" />
    </div>
  );
}
